var map = {
	"./All Icon.png": 55513,
	"./Basketball Icon.png": 41345,
	"./Cricket Icon.png": 67518,
	"./E-Games Icon.png": 87200,
	"./Handball Icon.png": 81241,
	"./Ice Hockey Icon.png": 1278,
	"./Kabaddi Icon.png": 95417,
	"./Snooker Icon.png": 13203,
	"./Soccer Icon.png": 23658,
	"./Table Tennis Icon.png": 15893,
	"./Tennis Icon.png": 86911,
	"./Volleyball Icon.png": 46327
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61006;